<template>
  <div
    :class="{
      [$style.container]: !hideTextarea,
      [$style.containerMinimal]: hideTextarea
    }"
  >
    <div
      v-if="!hideTextarea"
      :class="$style.label"
      data-test-id="CopyWell__label"
    >
      {{ label }}:
      <IconTooltip
        v-if="showTooltip"
        :tooltipContainerClass="$style.tooltip"
      >
        {{ tooltipLabel }}
      </IconTooltip>
    </div>
    <div :class="$style.contentContainer">
      <textarea
        ref="textarea"
        v-model="content"
        :class="$style.content"
        readonly="readonly"
        :rows="rows"
      />
      <IconButton
        :class="{[$style.button]: !hideTextarea}"
        data-test-id="CopyWell__button"
        hasNoBackground
        icon="copy"
        :inline="!hideTextarea"
        :text="buttonText"
        @click="copyToClipboard"
      />
    </div>
  </div>
</template>
<script>
import { IconButton } from '@jumpcloud/ui-components';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import IconCopy from 'public/img/icons/icon-copy.svg?inline';
import IconTooltip from 'client/components/Tooltip/IconTooltip.vue';
import util from 'client/util/index';

export default {
  name: 'CopyWell',

  components: {
    IconButton,
    IconTooltip,
  },

  props: {
    content: {
      type: String,
      default: '',
    },
    hideTextarea: Boolean,
    label: {
      type: String,
      default: '',
    },
    location: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: undefined,
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    tooltipLabel: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      IconCopy,
    };
  },

  computed: {
    buttonText() {
      return this.hideTextarea ? this.label : 'Copy';
    },
  },

  methods: {
    copyToClipboard() {
      this.$refs.textarea.select();
      document.execCommand('copy');
      util.notify('Copied to clipboard.');
      this.$emit('copyToClipboard');
      this.trackClick();
    },
    trackClick() {
      EventHelper.triggerCopyWellClicked({
        hideTextarea: this.hideTextarea,
        location: this.location,
      });
    },
  },
};
</script>
<style module scoped>
@import '../FormValidation/css/formFields.css';

@value ( jcGrey, jcPrimary, jcGrey800 ) from '~css/brand-colors.css';

.container {
  margin: 20px 0 20px 0;
}

.containerMinimal {
  display: inline-block;
  margin-left: var(--jc-spacer-medium);
}

.contentContainer {
  display: inherit;
  position: relative;
}

.content {
  background-color: white;
  border: 1px solid jcPrimary;
  border-radius: 2px;
  font-size: 16px;
  line-height: 1.4;
  padding: 8px 85px 8px 8px;
  resize: vertical;
  white-space: pre-wrap;
  width: 100%;
  word-wrap: break-word;
}

.containerMinimal .content {
  height: 0;
  opacity: 0;
  position: absolute;
  width: 0;
}

.content:focus {
  outline: none;
}

.content::selection {
  background-color: inherit;
}

.button.button {
  padding: var(--jc-button-padding);
  position: absolute;
  right: 6px;
  top: 4px;
}

.tooltip {
  margin-left: 5px;
  position: relative;
  top: 0;
}
</style>
